"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectService = void 0;
const getters_1 = require("../../functions/external/getters");
class SubjectService {
    interceptorService;
    clientService;
    store = {};
    constructor(interceptorService, clientService) {
        this.interceptorService = interceptorService;
        this.clientService = clientService;
    }
    generateId(event, roomName) {
        return `${event}:::${roomName}`;
    }
    parseId(storeId) {
        const [event, roomName] = storeId.split(':::');
        const [place, entity, scope, id] = roomName.split(':');
        return {
            event: (event ?? ''),
            roomName,
            scope: (scope ?? ''),
            place: (place ?? ''),
            entity: (entity ?? ''),
            id,
        };
    }
    getTargetFromRoomName(roomName) {
        return this.parseId(`:::${roomName}`);
    }
    subscribe(event, roomOrTarget, subscriber) {
        let target;
        let roomName;
        if (typeof roomOrTarget === 'string') {
            roomName = roomOrTarget;
            target = this.getTargetFromRoomName(roomOrTarget);
        }
        else {
            target = roomOrTarget;
            roomName = (0, getters_1.getRoomName)(roomOrTarget);
        }
        const id = this.generateId(event, roomName);
        if (!this.store[id]) {
            this.store[id] = [];
        }
        this.store[id].push(subscriber);
        this.clientService.join(target);
        const unsubscribe = () => this.unsubscribe(subscriber);
        const subscribeReturn = {
            roomName,
            unsubscribe,
        };
        this.interceptorService.onSubscribe(subscribeReturn);
        return subscribeReturn;
    }
    unsubscribe(subscriber) {
        Object.keys(this.store).forEach((id) => {
            const isSubscriberHere = (this.store[id] ?? []).some((sub) => sub === subscriber);
            if (isSubscriberHere) {
                this.store[id] = this.store[id].filter((sub) => sub !== subscriber);
                this.clientService.leave(this.getTargetFromRoomName(this.parseId(id).roomName));
            }
        });
    }
    unsubscribeFromCaseAndEvent(event, target) {
        Object.keys(this.store).forEach((id) => {
            const { event: storeEvent, place, entity, scope, roomName } = this.parseId(id);
            const currentParams = `${storeEvent}|${place}|${entity}|${scope}`;
            const targetParams = `${event}|${target.place}|${target.entity}|${target.scope}`;
            if (currentParams === targetParams) {
                this.store[id] = [];
                this.clientService.leave(this.getTargetFromRoomName(roomName));
            }
        });
    }
    unsubscribeFromCase(target) {
        Object.keys(this.store).forEach((id) => {
            const { place, entity, scope, roomName } = this.parseId(id);
            const currentParams = `${place}|${entity}|${scope}`;
            const targetParams = `${target.place}|${target.entity}|${target.scope}`;
            if (currentParams === targetParams) {
                this.store[id] = [];
                this.clientService.leave(this.getTargetFromRoomName(roomName));
            }
        });
    }
    unsubscribeAll() {
        Object.keys(this.store).forEach((id) => {
            this.store[id] = [];
            this.clientService.leave(this.getTargetFromRoomName(this.parseId(id).roomName));
        });
    }
    trigger(event, data) {
        try {
            Object.keys(this.store).forEach((id) => {
                const { event: targetEvent, roomName } = this.parseId(id);
                if (targetEvent.toString() !== event.toString() || !this.store[id] || roomName !== (0, getters_1.getRoomName)(data.target)) {
                    return;
                }
                this.store[id].forEach((subscriber) => subscriber(data.payload));
            });
        }
        catch (error) {
            console.error(`Error during socket event trigger`, error);
        }
    }
}
exports.SubjectService = SubjectService;
